export const APP_HOME = '/dashboard';
export const ADMIN_HOME = '/companies';
